import { InboxOutlined } from '@ant-design/icons';

import InventoryPage from 'src/pages/InventoryPage';

import { SiteMap } from './index';

export const inventoryRoutes: SiteMap = {
  inventory: {
    title: '재고 관리',
    page: InventoryPage,
    key: '/inventory',
    icon: <InboxOutlined />,
    children: [
      {
        label: '재고 정보',
        key: '/inventory/list',
        icon: null,
      },
      {
        label: '재고 설정',
        key: '/inventory/settings',
        icon: null,
      },
      {
        label: '거래처',
        key: '/inventory/supplier',
        icon: null,
      },
      {
        label: '거래처 입고 입력',
        key: '/inventory/supplier-inbound',
        icon: null,
      },
      {
        label: '거래처 입고 조회',
        key: '/inventory/supplier-inbound-list',
        icon: null,
      },
      {
        label: '재고 이슈',
        key: '/inventory/inventory-issue',
        icon: null,
      },
      {
        label: '입고 내역',
        key: '/inventory/inbound-history',
        icon: null,
      },
      {
        label: '출고 내역',
        key: '/inventory/outbound-history',
        icon: null,
      },
    ],
  },
};
